import { Link } from 'react-router-dom';
import SectionTitle from '../sectionTitle/SectionTitle';
import Card from '../card/Card';

const CasesCards = ({
  id,
  eyebrow,
  title,
  subtitle,
  items,
  ctaPrimaryLabel,
  ctaPrimaryHref,
  ctaSecondaryLabel,
  ctaSecondaryHref,
}) => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const hasSecondary = !!ctaSecondaryLabel && !!ctaSecondaryHref;
  const isPrimaryExternal =
    typeof ctaPrimaryHref === 'string' && ctaPrimaryHref.startsWith('http');
  const isSecondaryAnchor =
    typeof ctaSecondaryHref === 'string' && ctaSecondaryHref.startsWith('/#');
  const secondaryHrefResolved = isSecondaryAnchor
    ? `${publicUrl}${ctaSecondaryHref}`
    : ctaSecondaryHref;

  return (
    <section className="rn-section-gap pt--0" id={id}>
      <div className="container">
        <SectionTitle
          textAlign="text-center"
          radiusRounded=""
          subtitle={eyebrow}
          title={title}
          description={subtitle}
        />

        <div className="row mt--40">
          {(items || []).map((item, idx) => (
            <div
              className="col-lg-6 col-12 mt--30 d-flex align-items-stretch"
              key={idx}
            >
              <Card title={item.title}>
                <p className="description b1 color-gray">{item.description}</p>
                {!!item.tags?.length && (
                  <p className="description b2 color-gray mb--0">
                    <small>{item.tags.join(' · ')}</small>
                  </p>
                )}
              </Card>
            </div>
          ))}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="button-group text-center mt--50">
              {isPrimaryExternal ? (
                <a
                  className="btn-default btn-large round btn-icon"
                  href={ctaPrimaryHref}
                  target="_blank"
                  rel="noreferrer"
                >
                  {ctaPrimaryLabel}
                </a>
              ) : (
                <Link
                  className="btn-default btn-large round btn-icon"
                  to={ctaPrimaryHref}
                >
                  {ctaPrimaryLabel}
                </Link>
              )}
              {hasSecondary &&
                (isSecondaryAnchor ? (
                  <a
                    className="btn-default btn-large btn-border round btn-icon"
                    href={secondaryHrefResolved}
                  >
                    {ctaSecondaryLabel}
                  </a>
                ) : (
                  <Link
                    className="btn-default btn-large btn-border round btn-icon"
                    to={ctaSecondaryHref}
                  >
                    {ctaSecondaryLabel}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CasesCards;
